import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'

const getStatus= (sectionId,id,params)=>getAction("/ebid-ce/boOpenStatus/status/" + sectionId + "/" + id,params);

export {
  getStatus
}